import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { ApiProvider, createQueryClient } from '@fluxter/shared';
import { Toaster } from 'sonner';
import { ThemeProvider } from '@/components/theme/ThemeProvider';
import { TooltipProvider } from '@/components/ui/tooltip';
import { api } from './lib/api';
import { initNativeShell } from './lib/native-shell';
import { createAppRouter } from './router';
import './styles.css';

// Stamp the document element with `data-platform` + start tracking
// `data-window-focused`. Done before the router mounts so stylesheets
// see the right attributes on first paint and there's no flash of
// web-styled chrome inside the desktop shell. See `native-shell.ts`.
initNativeShell();

const queryClient = createQueryClient();
const router = createAppRouter(queryClient, api);

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={api}>
        <ThemeProvider>
          <TooltipProvider delayDuration={300}>
            <RouterProvider router={router} />
            <Toaster
              position="bottom-right"
              richColors
              closeButton
              toastOptions={{ className: 'font-sans' }}
            />
          </TooltipProvider>
        </ThemeProvider>
      </ApiProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
